<template>
  <div class="welcomeScreen">

    <!-- <GameScreen v-if="showGameScreen" :newDeck="newDeck" :useNewDeck="useNewDeck"/> -->
    <Game v-if="showGameScreen" :language="language"/>
    <DealerScreen v-if="showDealerScreen" :language="language" />
    <div v-if="showWelcome">
      
  <b-container >
	<div class="row card-row " id='mainHeight'>
        <!--<NavBar />-->
        <div class="col-sm-12 homeRow" id="homebg" >
		<div class="vertical-center">
		<img src="../assets/images/loterialockup.png" class="img-fluid logoHome mx-auto d-block" />
        <b-card :class="{ 'spanish-container': isSpanish }">
          <img :src="setPlayAs('../assets/images/play_as.png')" class="img-fluid logoHome mx-auto d-block" style="margin-top:0;margin-bottom:0!important;" />
          <hr style="margin-top:0;" />
          <h1 v-if="language === 'english'" class="menu-selectDark mb-4" @click="showDealer">Dealer</h1>
          <h1 v-else-if="language === 'spanish'" class="menu-selectDark mb-4" @click="showDealer">Comerciante</h1>

          <h1 v-if="language === 'english'" class="menu-selectDark mb-4" @click="showGame">Player</h1>
          <h1 v-else-if="language === 'spanish'" class="menu-selectDark mb-4" @click="showGame">Jugador</h1>

          <h1 v-if="language === 'english'" class="menu-selectDark mb-4 nofill_button" @click="$bvModal.show('rule-menu-modal');">Rules</h1>
          <h1 v-else-if="language === 'spanish'" class="menu-selectDark mb-4 nofill_button" @click="$bvModal.show('rule-menu-modal');">Reglas</h1>

          <div style="display:flex;justify-content:center;">
            <a v-if="language === 'english'" @click="switchLanguage('spanish')" href="#">Espanol</a>
            <a v-else-if="language === 'spanish'" @click="switchLanguage('english')" href="#">English</a>
          </div>
          
          
        </b-card>
		</div>
		</div>
      </div>
    </b-container>
    </div>
    <b-modal id="rule-menu-modal" size="xl" hide-footer>
      <RulesMenuView :language="language" />
    </b-modal>
  </div>
</template>


<script>
import Game from './Game'
import DealerScreen from './DealerScreen'
import RulesMenuView from './RulesMenuView'


export default {
  name: "WelcomeScreen",
  components: {Game, DealerScreen, RulesMenuView},
  created(){
    console.log("V5 dealer option Loaded.");
  },
  data(){
    return{
      showWelcome: true,
      showGameScreen: false,
      showBoardBuilder: false,
      useNewDeck: false,
      newDeck: null,
      showGameMenu: true,
      showTutView: false,
      showDealerScreen: false,
      language: "english"
    }
  },
  computed:{
    isSpanish: function(){
      if(this.language === 'spanish'){
        return true
      }else{
        return false
      }
    }
  },
  methods: {
    showGame(){
      this.showWelcome = false;
      this.showGameScreen = true;
      this.showGameMenu = false;
    },
    boardBuilder(){
      this.showWelcome = false;
      this.showGameScreen = false;
      this.showGameMenu = false;
      this.showBoardBuilder = true;
    },
    showTutorial(){
      this.showWelcome = false;
      this.showGameScreen = false;
      this.showGameMenu = false;
      this.showTutView = true;
    },
    showDealer(){
      this.showWelcome = false;
      this.showDealerScreen = true;
    },
    toHome(){
      this.showGameScreen = false;
      this.showWelcome = true;
      this.showDealerScreen = false;
    },
    switchLanguage(language){
      if(language === 'english'){
        this.language = 'english'
      }
      else if(language === 'spanish'){
        this.language = 'spanish'
      }
    },
    setPlayAs(language){
      if(this.language === "english"){
        return require('../assets/images/play_as.png')
      }
      else if (this.language === "spanish"){
        return require('../assets/images/play_as_spanish.png')
      }
    },
  }
};
</script>

<style lang="scss">
</style>
